import React, { useState, useEffect } from 'react';

import dynamic from 'next/dynamic';
import { Navbar } from './Navbar';
import { useAuth } from '../../providers/Auth';
import { useResponsive } from '../../client/utils/useResponsive';
import { isAPISupported } from '../../client/utils/isAPISupported';
import { CARS_NAV, HEALTH_NAV, PARTNER_NAV, ARTICLE_NAV, OFFER_NAV, SERVICE_NAV, LOGIN_NAV, USER_NAV, LOGOUT_NAV } from './navs';
import './Navigation.module.scss';

const Navigation = ({ dispatch }) => {
  const { isDesktop } = useResponsive();

  const [clientReady, setClientReady] = useState(false);
  const [shouldShowLogin, setShouldShowLogin] = useState(false);

  const {
    isAuthenticated,
    setAuthenticated,
    setMe,
    setAuthToken,
    setAgent,
    setTSOSupervisor,
    setRegistered,
    authToken,
  } = useAuth();

  const handleLogout = () => {
    dispatch({ type: 'LOG_OUT' });
    dispatch({ type: 'USER_LOGGED_OUT' });

    // clearing auth context
    setMe({});
    setAuthToken('');
    setAuthenticated(false);
    setAgent(false);
    setTSOSupervisor(false);
    setRegistered(false);

    // close the eventSource connection and resets it's value
    if (window.memoziedEventSource) {
      window.memoziedEventSource.close();
      window.memoziedEventSource = undefined;
    }

    // close the eventSource connection and resets it's value
    if (window.instantMessageSource) {
      window.instantMessageSource.close();
      window.instantMessageSource = undefined;
    }

    window.location.href = '/';
  };

  const getLoginModalView = () => {
    const LoginModal = dynamic(() => import('../../client/modules/account/components/LoginModal/LoginModal'));
    
    return (
      <LoginModal
        shouldShowLogin={shouldShowLogin}
        setShouldShowLogin={setShouldShowLogin}
      />
    )
  };

  const handleLogin = () => {
    if (!isAuthenticated && !authToken) {
      setShouldShowLogin(true);
      return;
    }
  };

  useEffect(() => {
    LOGIN_NAV.onClick = handleLogin;
    LOGOUT_NAV.onClick = handleLogout;

    if (isAPISupported('window')) {
      window.handleLogout = handleLogout;
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') setClientReady(true);
  }, [clientReady]);

  return (
    <div>
      <Navbar
        carMenu={CARS_NAV}
        healthMenu={HEALTH_NAV}
        partnerMenu={PARTNER_NAV}
        articleMenu={ARTICLE_NAV}
        serviceMenu={SERVICE_NAV}
        offerMenu={OFFER_NAV}
        guestMenu={LOGIN_NAV}
        authenticatedMenu={USER_NAV}
        isAuthenticated={isAuthenticated && authToken}
        loginAction={handleLogin}
        logoutAction={handleLogout}
        logoPath={'/static/images/lifepal-logo.svg'}
        isMobile={!isDesktop}
      />
      {shouldShowLogin && getLoginModalView()}
    </div>
  )
};

export default Navigation;
